import { action } from '@ember/object';
import Component from '@glimmer/component';

import { PopupEvent } from 'webapp/enums/enums';

import eq from 'webapp/helpers/eq';
import DataSelectEditTabComponent from 'webapp/components/data-select/edit/tab';

import type BlockSetup from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';
import type PopupModal from 'webapp/models-custom/popup/modal';

interface Args {
	popup: PopupModal; // for discard
	model: DataSelect[];
	selectedTab: DataSelect;
	changeTab: (ds: DataSelect) => void;
	blockSetup?: BlockSetup;
}

export default class DataSelectEditTabsComponent extends Component<Args> {
	@action
	changeTab(newTab: DataSelect): void {
		const currentTab = this.args.selectedTab;
		if (currentTab === newTab) {
			return;
		}

		// trigger PopupEvent.CLOSE_INTENT
		// if it returns true, we block switching tabs
		// pass special discard fn to call instead of closing whole popup
		const onDiscard = () => {
			currentTab.rollback();
			this.args.changeTab(newTab);
		};
		const eventResponses = this.args.popup.triggerEvent(PopupEvent.CLOSE_INTENT, onDiscard);
		if (eventResponses.some((response) => !!response)) {
			return;
		}

		this.args.changeTab(newTab);
	}
	<template>
		<ul class="modalTabs modalTabs-1">

			{{#each @model as |ds|}}
				<DataSelectEditTabComponent
					@model={{ds}}
					@isSelected={{eq @selectedTab ds}}
					@changeTab={{this.changeTab}}
					@blockSetup={{@blockSetup}}
				/>
			{{/each}}

		</ul>
	</template>
}
